import { createContentPropTypes } from '../../../helpers/content';

const content = {
	fromLabel: 'From',
	toLabel: 'To',
	amountLabel: 'Amount',
	totalAmountLabel: 'Total amount',
	typeLabel: 'Type',
	refLabel: 'Reference',
	createdByLabel: 'Created By',
	stopItWhenLabel: 'Stop it when?',
	bacsIdLabel: 'Bacs ID',
	submissionDateLabel: 'Submission Date',
	settlementDateLabel: 'Settlement Date',
	collectionDateLabel: 'Collection Date',
	individualPaymentsLabel: 'Individual payments',
	createdOnLabel: 'Created on',
	frequencyLabel: 'Frequency',
	endDateLabel: 'End date',
	noOfTimesLabel: 'After a number of times',
	nextDueLabel: 'Next Due',
	theirSortCodeLabel: 'Their sort code',
	theirAccountNumberLabel: 'Their account number',
	whenLabel: 'When',
	OneOffPaymenttype: 'One-off payment',
	lastAmountLabel: 'Last amount',
	lastPaidLabel: 'Last paid',
	lastPaymentReferenceLabel: 'Last payment reference',
	debitAmountLabel: 'Debit Amount',
	paymentFeesLabel: 'Payment fees',
	feesLabel: 'Fees',
	paymentSubmissionLabel: 'Payment submission date',
	paymentDateLabel: 'Payment date',
	exchangeRateLabel: 'Exchange rate',
	amountSentLabel: 'Amount Being Sent',
	estimatedSettlementLabel: 'Earliest estimated settlement date',
	reasonPaymentLabel: 'Reason for payment',
	authorisedByLabel: 'Authorised by',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
